(function () {
	// Função para verificar se o CSS está aplicado
	function isCSSReady(element) {
		const computedStyle = window.getComputedStyle(element);
		return computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden';
	}

	// Função para inicializar o carrossel
	function initializeCarousel(element) {
		const slides = element.querySelectorAll(".glide__slide");
		const ingredientCount = slides.length;
		const isDesktop = window.innerWidth > 1024;
		const slidesPerView = parseInt(element.getAttribute('data-slides-per-view')) || 4;

		if (isDesktop && ingredientCount <= slidesPerView) {
			// Desativar botões
			const prevButton = element.querySelector(".carousel-prev");
			const nextButton = element.querySelector(".carousel-next");

			if (prevButton) {
				prevButton.disabled = true;
				prevButton.style.opacity = "0.5";
				prevButton.style.cursor = "not-allowed";
			}
			if (nextButton) {
				nextButton.disabled = true;
				nextButton.style.opacity = "0.5";
				nextButton.style.cursor = "not-allowed";
			}

			// Configuração para mostrar todos sem scroll
			new Glide(element, {
				type: "slider",
				perView: slidesPerView,
				gap: 20,
				animationDuration: 150,
				dragThreshold: false,
				breakpoints: {
					1024: { perView: ingredientCount, swipeThreshold: false },
					768: { perView: 1.15, gap: 32, swipeThreshold: true },
				},
				bullets: true,
				rewind: false,
				bound: true,
			}).mount();
		} else {
			// Configuração normal
			new Glide(element, {
				type: "slider",
				perView: slidesPerView,
				gap: 20,
				animationDuration: 150,
				breakpoints: {
					1024: { perView: 2.2, swipeThreshold: true },
					768: { perView: 1.15, gap: 32, swipeThreshold: true },
				},
				bullets: true,
				bound: true,
				rewind: false,
			}).mount();
		}
	}

	// Função para aguardar CSS estar pronto
	function waitForCSSReady(elements) {
		elements.forEach((element) => {
			if (isCSSReady(element)) {
				initializeCarousel(element);
			} else {
				// Aguardar próximo frame para verificar novamente
				requestAnimationFrame(() => waitForCSSReady([element]));
			}
		});
	}

	// Inicializar quando DOM estiver pronto
	document.addEventListener("DOMContentLoaded", () => {
		const carouselElements = document.querySelectorAll('[id^="image-carousel-"]');
		
		if (carouselElements.length > 0) {
			waitForCSSReady(Array.from(carouselElements));
		}
	});
})();